module.exports = __webpack_public_path__ + "static/media/fifteen_percent_discount.a41b0be2.svg";